let status = {}

const updateStatus = (uid, last_seen, flag) => {
  status[uid] = {
    status: flag,
    last_seen: last_seen || 0
  }
}

const workerStatus = {
  updateStatus,
  status
}

module.exports = workerStatus